var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-edit-isbn"},[_c('error',{attrs:{"err":_vm.error},on:{"update:err":function($event){_vm.error=$event}}}),(_vm.render)?_c('form-generator',{attrs:{"elements":_vm.elements,"data":_vm.isbn,"handleUpdate":({ key }, v) => (_vm.isbn[key] = v)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }